import { render, staticRenderFns } from "./OldPrintLists.vue?vue&type=template&id=c6471f68&scoped=true&"
import script from "./OldPrintLists.vue?vue&type=script&lang=js&"
export * from "./OldPrintLists.vue?vue&type=script&lang=js&"
import style0 from "./OldPrintLists.vue?vue&type=style&index=0&id=c6471f68&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6471f68",
  null
  
)

export default component.exports